import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const selectedTracksFromStorage = localStorage.getItem("selectedTrackBoxes");
const selectedSuperTracksFromStorage = localStorage.getItem(
  "selectedSupertracks"
);

const initialState = {
  superTracks: null,
  trackBoxes: null,
  match: null,
  frameCount: 0,
  fps: 60,
  error: null,
  selectedTracks: JSON.parse(selectedTracksFromStorage) || [],
  doubleClickedTrack: null,
  isVideoStart: false,
  tracksMap: new Map(),
  isCutActive: false,
  cutFrame: 0,
  superTrackStartTime: localStorage.getItem("start") || 0,
  superTrackEndTime: localStorage.getItem("end") || 5,
  superTrackGlobalVideoDuration: 0,
  isSelectSuperTrack: false,
  highlightedSuperTracks: [],
  selectedSuperTrack: null,
  selectedSuperTracks: JSON.parse(selectedSuperTracksFromStorage) || {},
  teams: {
    left_team: [],
    right_team: [],
    ball: [],
  },
  boxes: {},
  newBoxes: {},
  changedKeyFrames: [],
  hasChanges: false,
};

export const updateProgress = createAsyncThunk(
  "dashboard/updateProgress",
  async (data, { dispatch }) => {
    dispatch(updateSuperTrack(data));
    dispatch(setNewBoxes({}));
  }
);

const supertrackSlice = createSlice({
  name: "supertrack",
  initialState,
  reducers: {
    setSuperTracks: (state, action) => {
      const superTracks = action.payload;
      const newTeams = {
        left_team: [],
        right_team: [],
        ball: [],
      };
      const teamLabels = {
        first_team: "left_team",
        second_team: "right_team",
      };
      for (const id in superTracks) {
        const { kind } = superTracks[id];
        if (kind) {
          newTeams[
            ["first_team", "second_team"].includes(kind)
              ? teamLabels[kind]
              : kind
          ]?.push(id);
        }
      }
      state.superTracks = action.payload;
      state.teams = newTeams;
      state.error = null;
    },
    setSelectedSuperTrack: (state, action) => {
      state.selectedSuperTrack = action.payload;
    },
    setFrameBoxes: (state, action) => {
      state.trackBoxes = action.payload;
      state.error = null;
    },
    appendFrameBoxes: (state, action) => {
      const { newBoxes } = action.payload;
      Object.assign(state.trackBoxes, newBoxes);
    },
    mergeTrackBoxesChunk: (state, action) => {
      const newBoxes = action.payload;
      if (!state.trackBoxes) { state.trackBoxes = newBoxes; return; }
      for (const trackId in newBoxes) {
        if (state.trackBoxes[trackId]) {
          state.trackBoxes[trackId] = { ...state.trackBoxes[trackId], ...newBoxes[trackId] };
        } else {
          state.trackBoxes[trackId] = newBoxes[trackId];
        }
      }
    },
    setFrameCount: (state, action) => {
      state.frameCount = action.payload;
    },
    setFps: (state, action) => {
      state.fps = action.payload;
      state.error = null;
    },
    updateMatch: (state, action) => {
      state.match = action.payload;
      state.error = null;
    },
    updateError: (state, action) => {
      state.error = action.payload;
    },
    updateSuperTrack: (state, action) => {
      const { tracks, superTrackId } = action.payload;
      if (!state.superTracks) {
        console.warn("superTracks is null");
        return;
      }
      const trackIds = tracks.map((t) => t.track_id);
      const superTrack = state.superTracks[Number(superTrackId)];
      if (!superTrack) {
        console.warn(`superTrack with id ${superTrackId} not found`);
        return;
      }
      const filtered = superTrack.tracks.filter(
        (t) => !trackIds.includes(t.track_id)
      );
      state.superTracks[superTrackId].tracks = [...filtered, ...tracks];
    },
    setSelectedSuperTracks: (state, action) => {
      localStorage.setItem(
        "selectedSupertracks",
        JSON.stringify(action.payload)
      );
      state.selectedSuperTracks = action.payload;
    },
    setSelectedTracks: (state, action) => {
      localStorage.setItem(
        "selectedTrackBoxes",
        JSON.stringify(action.payload)
      );
      state.selectedTracks = action.payload;
    },
    updateSelectedTracks: (state, action) => {
      const { isAdding, ids } = action.payload;
      // Remove existing selected tracks
      if (Array.isArray(ids)) {
        const hasGotSelectedTrack = ids.some((id) =>
          state.selectedTracks.includes(id)
        );

        if (!isAdding && hasGotSelectedTrack) {
          const selectedTracks = state.selectedTracks.filter(
            (track) => !ids.includes(track)
          );

          localStorage.setItem(
            "selectedTrackBoxes",
            JSON.stringify(selectedTracks)
          );

          state.selectedTracks = selectedTracks;
        } else if (isAdding) {
          localStorage.setItem(
            "selectedTrackBoxes",
            JSON.stringify([...state.selectedTracks, ...ids])
          );

          state.selectedTracks = [...state.selectedTracks, ...ids];
        }
      }
    },
    updateHighlightedSuperTracks: (state, action) => {
      state.highlightedSuperTracks = action.payload;
    },
    updateTrackSelectedForSeek: (state, action) => {
      if (action.payload) {
        state.selectedTracks = state.selectedSuperTrack
          ? state.selectedTracks
          : [action.payload.track_id];
        state.doubleClickedTrack = action.payload;
      } else {
        state.doubleClickedTrack = null;
      }
    },
    mergeSuperTrack: (state, action) => {
      const { targetId, superTrackId } = action.payload;

      if (!state.superTracks) return;

      if (!state.superTracks[targetId]) {
        toast.warning(
          `MERGE_SUPER_TRACK1: The supertrack with ID ${targetId} is not found. This problem could be happening because the data is not synchronized correctly.`
        );
        return;
      }

      if (!state.superTracks[Number(superTrackId)]) {
        toast.warning(
          `MERGE_SUPER_TRACK2: The supertrack with ID ${superTrackId} is not found. This problem could be happening because the data is not synchronized correctly.`
        );
        return;
      }

      if (!state.superTracks[targetId].tracks) {
        toast.warning(
          `MERGE_SUPER_TRACK3: The supertrack with ID ${targetId} has no tracks.`
        );
        return;
      }

      if (!state.superTracks[Number(superTrackId)].tracks) {
        toast.warning(
          `MERGE_SUPER_TRACK4: The supertrack with ID ${superTrackId} has no tracks.`
        );
        return;
      }

      const sourceTracks = state.superTracks[Number(superTrackId)].tracks.filter(
        ({ track_id }) => track_id != null
      );
      state.superTracks[targetId].tracks.push(...sourceTracks);
      delete state.superTracks[superTrackId];
    },
    moveTracks: (state, action) => {
      const { fromId, toId, trackIds } = action.payload;
      if (!state.superTracks?.[fromId] || !state.superTracks?.[toId]) return;
      const from = state.superTracks[fromId];
      const moving = [];
      const remaining = [];
      from.tracks.forEach((track) => {
        if (track.track_id != null && trackIds.includes(track.track_id)) {
          moving.push(track);
        } else {
          remaining.push(track);
        }
      });
      from.tracks = remaining;
      state.superTracks[toId].tracks.push(...moving);
    },
    cutSuperTrack: (state, action) => {
      const { superTrackId, newSuperTrack, trackIds } = action.payload;
      const superTrack = state.superTracks[superTrackId];
      let leftTracks = [],
        rightTracks = [];
      superTrack.tracks.forEach((t) => {
        if (trackIds.includes(t.track_id)) {
          rightTracks.push(t);
        } else {
          leftTracks.push(t);
        }
      });
      const { super_track_uid, match, team, player } = newSuperTrack;
      state.superTracks[superTrackId] = {
        ...superTrack,
        tracks: leftTracks,
      };
      state.superTracks[super_track_uid] = {
        tracks: rightTracks,
        isHidden: false,
        player,
        team,
        match,
      };
    },
    setVideoStart: (state, action) => {
      state.isVideoStart = action.payload ?? false;
    },
    deleteSuperTrack: (state, action) => {
      const superTrackId = action.payload;
      delete state.superTracks[superTrackId];
    },
    addSuperTrack: (state, action) => {
      const { super_track_uid, tracks_data, match, team, player } =
        action.payload;
      if (!state.superTracks) {
        console.warn("superTracks is null");
        return;
      }
      state.superTracks[super_track_uid] = {
        tracks: tracks_data,
        isHidden: false,
        player,
        team,
        match,
      };
    },
    deleteTrack: (state, action) => {
      const { superTrackId, track_id } = action.payload;
      if (!state.superTracks) {
        console.warn("superTracks is null");
        return;
      }
      const superTrack = state.superTracks[superTrackId];
      if (!superTrack) {
        console.warn(`SuperTrack with id ${superTrackId} not found`);
        return;
      }
      const filtered = superTrack.tracks.filter((t) => t.track_id !== track_id);
      state.superTracks[superTrackId].tracks = filtered;
    },
    setTracksMap: (state, action) => {
      state.tracksMap = action.payload;
    },
    setCutActive: (state, action) => {
      state.isCutActive = action.payload;
    },
    setCutFrame: (state, action) => {
      state.cutFrame = action.payload;
    },
    setSuperTrackStartTime: (state, action) => {
      state.superTrackStartTime = action.payload;
    },
    setSuperTrackEndTime: (state, action) => {
      state.superTrackEndTime = action.payload;
    },
    setSuperTrackGlobalVideoDuration: (state, action) => {
      state.superTrackGlobalVideoDuration = action.payload;
    },
    setSelectSuperTrack: (state, action) => {
      state.isSelectSuperTrack = action.payload;
    },
    cutOff: (state, action) => {
      const { tracks, superTrackId, trackId, newSuperTrack } = action.payload;
      const { super_track_uid, match, team, player } = newSuperTrack;
      state.superTracks[superTrackId].tracks = [
        ...tracks.filter(({ track_id }) => track_id !== trackId),
      ];
      state.superTracks[super_track_uid] = {
        tracks: [tracks.find(({ track_id }) => track_id === trackId)],
        isHidden: false,
        player,
        team,
        match,
      };
    },
    setBoxes: (state, action) => {
      state.boxes = action.payload;
    },
    setNewBoxes: (state, action) => {
      state.newBoxes = action.payload;
    },
    setChangedKeyFrames: (state, action) => {
      state.changedKeyFrames = action.payload;
    },
    setHasChanges: (state, action) => {
      state.hasChanges = action.payload;
    },
  },
});

export const {
  setSuperTracks,
  setSelectedSuperTrack,
  setFrameBoxes,
  appendFrameBoxes,
  mergeTrackBoxesChunk,
  setFrameCount,
  setFps,
  updateMatch,
  updateError,
  updateSuperTrack,
  setSelectedSuperTracks,
  setSelectedTracks,
  updateSelectedTracks,
  updateHighlightedSuperTracks,
  updateTrackSelectedForSeek,
  mergeSuperTrack,
  moveTracks,
  cutSuperTrack,
  setVideoStart,
  deleteSuperTrack,
  addSuperTrack,
  deleteTrack,
  setTracksMap,
  setCutActive,
  setCutFrame,
  setSuperTrackStartTime,
  setSuperTrackEndTime,
  setSuperTrackGlobalVideoDuration,
  setSelectSuperTrack,
  cutOff,
  setBoxes,
  setNewBoxes,
  setChangedKeyFrames,
  setHasChanges,
} = supertrackSlice.actions;

export default supertrackSlice.reducer;
